import { render, staticRenderFns } from "./DetailCard.vue?vue&type=template&id=4a414ddf&scoped=true&"
import script from "./DetailCard.vue?vue&type=script&lang=js&"
export * from "./DetailCard.vue?vue&type=script&lang=js&"
import style0 from "./DetailCard.vue?vue&type=style&index=0&id=4a414ddf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a414ddf",
  null
  
)

export default component.exports